import React from 'react'
import { useGlobal } from 'reactn'
import ReactSwipe from 'react-swipe'
import IWF from '../components/image-with-fallback'
import development from '../images/home-artist-development-mobile.png'
import marketing from '../images/home-artist-marketing-mobile.png'
import management from '../images/home-artist-management-mobile.png'
import Nav from '../components/nav'
import Footer from '../components/footer'
import { Link } from 'gatsby'
import { useState, useEffect } from 'react'
import './carousel.css'

if (typeof document !== 'undefined') {
  var root = document.querySelector(':root')
}

const Carousel = () => {

  // global state

  const [showConnectModal, setShowConnectModal] = useGlobal('showConnectModal')


  useEffect(() => {
      root.style.setProperty('--backgroundLeft', 'white')
      root.style.setProperty('--backgroundCenter', 'none')
      root.style.setProperty('--backgroundRight', 'none')
    return function cleanup() {
      root.style.setProperty('--backgroundLeft', 'white')
      root.style.setProperty('--backgroundCenter', 'none')
      root.style.setProperty('--backgroundRight', 'none')
    }
  }, )

  let reactSwipeEl
  const [swipeSpeed, setSwipeSpeed] = useState(200)
  const slideImages = [development, marketing, management]
  const slideHeading = ['DEVELOPMENT', 'MARKETING', 'MANAGEMENT']
  const slideServices = [

    ['SONGWRITING DEVELOPMENT',
    'SOUND DEVELOPMENT',
    'FINDING COLLABORATORS'],

    ['CREATING MARKETING PLANS',
      'MANAGING PRESS STRATEGY',
      'PRODUCING MUSIC VIDEOS'
    ],

    [
      'NEGOTIATING DEALS',
      'MANAGING FINANCES & ACCOUNTING',
      'PAPERWORK ADMINISTRATION'
    ]
  ]

  
  const numberOfSlides = 3

  const links = ['/development/', '/marketing/', '/management/']

  let vh

  const paneNodes = Array.apply(null, Array(numberOfSlides)).map((_, i) => {

    return (
      <div key={i} className="slide-wrapper" style={{width: "100vw", margin: 0, padding: 0}}>
        <div className="item">
          <div style={{
            width: '100vw',
            height: '100vh',
            margin: 0,
            padding: 0,
            backgroundImage: `url(${slideImages[i]})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            display: 'flex',
            flexDirection: 'column',            
            
          }}>
            <div className="carousel-text">
              <h1 className="mobile-top-heading">{slideHeading[i]}</h1>
            </div>
            <ul className="service-block-mobile">
              <li className="services-include-mobile">SERVICES INCLUDE</li>
              <div className="mobile-service-triad">
                <li className="mobile-service-triad-text">{slideServices[i][0]}</li>
                <li className="mobile-service-triad-text">{slideServices[i][1]}</li>
                <li className="mobile-service-triad-text">{slideServices[i][2]}</li>
              </div>
            </ul>
            <Link to={links[i]} className="carousel-button-link">
              <div id="carousel-button">
                <span className="carousel-learn-more">LEARN MORE</span>
              </div>
            </Link>  
            {/* <div className="sub-divider-container-mobile" onClick={() => {
              scroller.scrollTo('future-artist-management', {
                duration: 500,
                delay: 100,
                smooth: true,
                offset: -20
              })                        
            }}>  
              <span className="carousel-sub-divider-text">WHAT IS CREATESAFE?</span>
              <img src={downArrowWhite} className="carousel-down-arrow white-arrow"/>                
            </div>                       */}
          </div>
        </div>
      </div>
    )
  })

  const startSlide = 0;
  const swipeOptions = {
    startSlide: 0,
    auto: 3000,
    speed: swipeSpeed,
    callback(index) {
      setSwipeSpeed(0)
      switch(index){
        case 0:
          console.log(index)
          root.style.setProperty('--backgroundLeft', 'white')
          root.style.setProperty('--backgroundCenter', 'none')
          root.style.setProperty('--backgroundRight', 'none')
          break
        case 1:
          root.style.setProperty('--backgroundLeft', 'none')
          root.style.setProperty('--backgroundCenter', 'white')
          root.style.setProperty('--backgroundRight', 'none')
          break
        case 2:
          root.style.setProperty('--backgroundLeft', 'none')
          root.style.setProperty('--backgroundCenter', 'none')
          root.style.setProperty('--backgroundRight', 'white')
          break        
      }
    },
    transitionEnd() {
      console.log("ended transition");
    }
  }

  return (
    <div className="mobile-index">
      <Nav/>
      <ReactSwipe
        
        className="mySwipe"
        swipeOptions={swipeOptions}
      >
        {paneNodes}
      </ReactSwipe>
      <div className="mobile-sub-heading sub-one">
        <h2 className="mobile-sub-heading-text">ARTIST</h2>
      </div>
      <div className="mobile-sub-heading sub-two">
        {/* <h2 className="mobile-sub-heading-text">ON-DEMAND</h2>       */}
      </div>      
      <div className="ovals">
        <div className="oval oval-left"  />
        <div className="oval oval-center"  />
        <div className="oval oval-right" />
      </div>
      <div className="mobile-index-wrapper">
        <div className="future-artist-management">
          <p className="sub-divider-heading sub-divider-heading-mobile">THE FUTURE OF ARTIST MANAGEMENT</p>
        </div>
        <IWF fileName="meet-concierge-mobile" className="phone phone-mobile" />
        <div className="bottom-container carousel-bottom-container">
          <div className="bottom-left-wrapper-mobile">
            <p className="meet-createsafe">CREATE O/S</p>
            <p className="bottom-text-block carousel-text-block">
              We are building a world where artists are in command. A first-of-its-kind CRM platform for creators to secure the necessary resources for making, managing, and marketing their art. Via our machine-human hybrid concierge, we deliver scalable management solutions and an unprecedented suite of tools for artists and managers alike. CreateSafe empowers creators and their teams to control their own enterprises through technology, executive development, agency marketing, and creative management services.
            </p>
            <button onClick={() => setShowConnectModal(true)} className="black-button mobile-index-bottom-button cta">CONNECT NOW</button>
          </div>
        </div>
        <hr className="carousel-index-divider" />
      </div>  
      <Footer />
    </div>
  )
}

export default Carousel